import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';
import { Http, Response, ResponseContentType } from '@angular/http';

@Injectable()
export class NonMemberActivityService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  getAllCurrentNonMemberActivities(){
    return this.authHttp.get("/api/nonmembersubscriptions/").map(res => {
        let value = "";
        if (res.status == 200){
            value = res.json()
        }
        return {'status':res.status, 'value': value}
      });
  }

  getNonMemberActivitiesById(id: number){
    return this.authHttp.get("/api/nonmembersubscriptions/ById/"+id).map(res => {
        let value = "";
        if (res.status == 200){
            value = res.json()
        }
        return {'status':res.status, 'value': value}
      });
  }

  create(nonmemberSub: any) {
    // console.log("in Create nonMemberActivityService");
    // console.log(nonmemberSub);
    
    
    return this.authHttp.post('/api/nonmembersubscriptions/subscribe', nonmemberSub).map( res => {
        console.log();
        let value = "";
        if (res.status == 200){
            value = res.json()
        }
        return {'status':res.status, 'value': value}
    });
  }

  getAllYearsOfSubscriptions(){
    return this.authHttp.get("/api/nonmembersubscriptions/GetAllYearsOfSubscriptions").map(res => {
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

  getAllSubscriptionsByYear(year: number){
    return this.authHttp.get("/api/nonmembersubscriptions/year/"+year).map(res => {
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

  changeClosed(id: number, open: boolean){
    return this.authHttp.get("/api/nonmembersubscriptions/open/"+id+"/"+open).map(res => res.status);
  }

  createNewActivity(activity: any){
    return this.authHttp.post('/api/nonmembersubscriptions/', activity).map( (res:any) => {
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    })
  }

  updateActivity(activity: any){
    return this.authHttp.put('/api/nonmembersubscriptions/', activity).map(res =>{
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

  delete(id: number){
    return this.authHttp.delete('/api/nonmembersubscriptions/'+id).map( res=> {
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

  getAllSubscriptionsForActivity(id: number){
    return this.authHttp.get("/api/nonmembersubscriptions/sublist/"+id).map(res => {
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

  deleteSubsciptionFromActivity(id: number){
    return this.authHttp.delete("/api/nonmembersubscriptions/nonMemberSubsiption/"+id).map(res => {
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

  updateSubsciptionFromActivity(nonmemberSub:any){
    return this.authHttp.put('/api/nonmembersubscriptions/nonMemberSubsiption', nonmemberSub).map( (res:any) => {
      console.log();
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }
  
  downloadExcel(id: number) {
    return this.authHttp.get('/api/nonmembersubscriptions/generateXlsx/'+id, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }


}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/nonMemberActivity.service.ts